import React from "react";
import IdentityArrival from "./IdentityArrival";
export default function Signup() { return <IdentityArrival mode="signup" />; }
